import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/medios-inscripcion";

export const getMediosInscripcion = async () => {
    try {
        const response = await apiClient(URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();
        if(response.status !== 200) {
            throw new Error(data.message || "Error al obtener los medios de inscripción");
        }
        
        return data
    } catch (error) {
        throw error
    }
}


export const putMedioInscripcion = async (medioInscripcion) => {
    try {
        
        const response = await apiClient(URL, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...medioInscripcion
            })
        });
        const data = await response.json();
        if(response.status !== 200) {
            throw new Error(data.message || "Error al actualizar el medio de inscripción");
        }
        
        return data
    } catch (error) {
        throw error
    }
}

export const deleteMedioInscripcion = async (cod) => {
    try {
        const response = await apiClient(`${URL}/${cod}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const data = await response.json();
        if(response.status !== 200) {
            throw new Error(data.message || "Error al eliminar el medio de inscripción");
        }
        return data
    } catch (error) {
        throw error
    }
}

export const postMedioInscripcion = async (medioInscripcion) => {
    try {
        const response = await apiClient(URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...medioInscripcion
            })
        });
        const data = await response.json();
        if(response.status !== 201) {
            throw new Error(data.message || "Error al crear el medio de inscripción");
        }
        return data
    } catch (error) {
        throw error
    }
}
